import styled from 'styled-components';

export const CheckboxWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  font-size: 12px;
  margin-bottom: 25px;

  color: ${({ isConnected, isActive }) => {
    if (!isConnected) return 'var(--red)';
    if (isConnected && !isActive) return 'var(--yellow)';
    return 'var(--brand-green)';
  }};
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 10px;
  gap: 5px;

  span {
    font-size: 12px;
    font-weight: 800;
  }

  input {
    border-radius: 8px;
    background-color: #333333;

    &:hover,
    &:active,
    &:focus {
      border-color: var(--brand-green) !important;
    }
  }
`;

export const MainWrapper = styled.div`
  width: 218px;
  padding: 20px;

  .additional-info {
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: var(--text-color-medium-gray);
    margin-top: 32px;
  }
`;

export const TextGroup = styled.div`
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 12px;
  color: var(--text-color-medium-gray);
`;

export const TextHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 17px;
  font-weight: 800;
  color: var(--text-color);
`;

export const StatusWrapper = styled.div`
  border-radius: 10px;
  background-color: var(--white-box-background);
  color: var(--text-color-medium-gray);
  font-size: 12px;
  text-align: start;
  padding: 25px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .spinner-path {
    stroke: #000 !important;
  }
`;

export const StatusTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const StatusTextHeading = styled.div`
  font-size: 17px;
  font-weight: 800;
  color: var(--text-color);
`;

export const StatusTextAdditional = styled.div`
  button {
    margin-left: 8px;
    color: var(--text-color);
  }
`;

export const StatusControl = styled.div`
  color: ${({ variant }) => (variant === 'success' ? 'var(--brand-green)' : 'var(--red)')};
`;
